import React, { useState } from "react";
import { updateBasicDetails } from "../../../services/UserServices/UserService";
import { notifyError, notifyTopRight } from "../Common/Toaster";
import { Modal } from "react-bootstrap";

export default function UserUpdate({ show, onHide, table, user }) {
  // user = { userId, name, email, countryCode, phoneNumber, age }

  const errorsObj = { name: "" };
  const [errors, setErrors] = useState(errorsObj);

  const [formData, setFormData] = useState({
    userId: user?._id || "",
    name: user?.name || "",
    email: user?.email || "",
    countryCode: user?.countryCode || "",
    phoneNumber: user?.phoneNumber || "",
    age: user?.age ?? "",
  });

  const [loader, setLoader] = useState(false);

  const handleInput = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    let error = false;
    const errorObj = { ...errorsObj };

    if (formData?.name.trim() === "") {
      errorObj.name = "Name is required";
      error = true;
    }

    setErrors(errorObj);
    if (error) return;

    setLoader(true);
    try {
      const payload = {
        ...formData,
        age: formData.age === "" ? formData.age : Number(formData.age),
      };
      const response = await updateBasicDetails(payload);
      notifyTopRight(response?.data?.message || "User updated successfully");
      onHide();
      table(); // refresh table
    } catch (err) {
      notifyError(err?.response?.data?.message || "Failed to update user");
    } finally {
      setLoader(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <form onSubmit={onSubmit}>
        <div className="modal-header">
          <h4 className="modal-title fs-20">Update User Details</h4>
        </div>
        <div className="modal-body">
          <div className="form-group mb-3">
            <label className="text-black font-w500">Name</label>
            <input
              className="form-control"
              name="name"
              value={formData.name}
              onChange={handleInput}
            />
            {errors.name && (
              <div className="text-danger fs-12">{errors.name}</div>
            )}
          </div>

          <div className="form-group mb-3">
            <label className="text-black font-w500">Email</label>
            <input
              type="email"
              className="form-control"
              name="email"
              value={formData.email}
              onChange={handleInput}
            />
          </div>

          <div className="form-group mb-3">
            <label className="text-black font-w500">Age</label>
            <input
              type="number"
              className="form-control"
              name="age"
              value={formData.age}
              onChange={handleInput}
              min={18}
              max={99}
            />
          </div>

          <div className="form-group mb-3">
            <label className="text-black font-w500">Country Code</label>
            <input
              className="form-control"
              name="countryCode"
              value={formData.countryCode}
              onChange={handleInput}
              placeholder="e.g. 65"
              maxLength={5}
            />
          </div>

          <div className="form-group mb-3">
            <label className="text-black font-w500">Phone Number</label>
            <input
              className="form-control"
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleInput}
              maxLength={15}
            />
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" onClick={onHide} className="btn btn-danger">
            <i className="flaticon-delete-1"></i> Cancel
          </button>
          <button type="submit" className="btn btn-primary">
            {loader ? "Updating..." : "Update"}
          </button>
        </div>
      </form>
    </Modal>
  );
}
